(function () {
  var DESKTOP = '(min-width: 1024px)';
  var BOTTOM_GAP = 24;
  var THRESHOLD = 8;
  var COLLAPSE_MS = 280;
  var panel = null;
  var tracking = null;

  function getPanel() {
    return document.querySelector('[data-product-info-panel]');
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function getLift(el) {
    return parseFloat(el.style.getPropertyValue('--product-panel-lift')) || 0;
  }

  function setLift(el, value) {
    var lift = Math.max(0, Math.round(value));
    if (lift < THRESHOLD) lift = 0;
    el.style.setProperty('--product-panel-lift', lift + 'px');
    el.classList.toggle('is-panel-lifted', lift > 0);
  }

  function resetLift(el) {
    if (!el) return;
    el.style.setProperty('--product-panel-lift', '0px');
    el.classList.remove('is-panel-lifted');
  }

  function measureOverflow(el) {
    var lift = getLift(el);
    var rect = el.getBoundingClientRect();
    var naturalBottom = rect.bottom + lift;
    return naturalBottom - (window.innerHeight - BOTTOM_GAP);
  }

  function updateLift() {
    panel = getPanel();
    if (!panel) return;
    if (!isDesktop()) {
      resetLift(panel);
      return;
    }
    setLift(panel, Math.max(0, measureOverflow(panel)));
  }

  function trackUntilSettled() {
    var start = performance.now();
    panel = getPanel();
    if (panel) panel.classList.add('is-panel-lifting');
    if (tracking) cancelAnimationFrame(tracking);

    function tick() {
      updateLift();
      if (performance.now() - start < COLLAPSE_MS) {
        tracking = requestAnimationFrame(tick);
      } else {
        tracking = null;
        if (panel) panel.classList.remove('is-panel-lifting');
        updateLift();
      }
    }

    tracking = requestAnimationFrame(tick);
  }

  function onTabClick(event) {
    if (!event.target.closest('.collapsible-tab button')) return;
    requestAnimationFrame(trackUntilSettled);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateLift, 100);
  }

  document.addEventListener('click', onTabClick);
  window.addEventListener('resize', onResize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLift);
  } else {
    updateLift();
  }
})();
